module.exports = __webpack_public_path__ + "img/gg.5b913b28.svg";